import type { IPrimarySidebarItem, ISubSectionItem } from "app/components/sidebar3/types";
import { EGroupTypes, ESidebarPlacement } from "app/components/sidebar3/types";

const createCompaniesAndContactsSection = (groupedSubSection: ISubSectionItem[]): IPrimarySidebarItem => ({
    title: "primary.sidebar.salesIntelligence.findCompaniesContacts.title",
    itemType: EGroupTypes.GroupPrimaryLevel,
    placement: ESidebarPlacement.Top,
    groupedSubSection,
});

export default createCompaniesAndContactsSection;
